import { render, staticRenderFns } from "./OurWork.vue?vue&type=template&id=0899f04c&scoped=true&"
import script from "./OurWork.vue?vue&type=script&lang=js&"
export * from "./OurWork.vue?vue&type=script&lang=js&"
import style0 from "./OurWork.vue?vue&type=style&index=0&id=0899f04c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0899f04c",
  null
  
)

export default component.exports